import {
  fetchLangstonSuggestions,
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/SearchMenu/SearchMenu.services';

export const fetchSuggestions = async({
  fragment = '',
}) => {
  const {results} = await fetchLangstonSuggestions(fragment);
  return results;
};
